module.exports = __webpack_public_path__ + "static/media/potatoes.7c32747d.webp";